export enum DataFeedHealthLevel {
    Healthy,
    Warning,
    Error
}